import { render, staticRenderFns } from "./Candidacy.vue?vue&type=template&id=787e0f00&"
import script from "./Candidacy.vue?vue&type=script&lang=js&"
export * from "./Candidacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports